import React, { useState } from 'react'
import { WebCourses } from '../providers/courses/CoursesProvider'
import CourseCardSection from './courses/CourseCardSection'
import CourseFilterSection from './courses/CourseFilterSection'
import CourseListSection from './courses/CourseListSection'
import Footer from './Sections/Footer'
import Header from './Sections/Header'

const CoursesScreen = () => {

    const [displayStyle, setDisplayStyle] = useState('card');
    const [courses, setCourses] = useState(WebCourses);

    const handleFilter = (criteres = { level: "", hours: "", type: "" }) => {
        console.log(criteres);

        let result = WebCourses;
        if (criteres.level && criteres.level != "all") {
            result = result.filter((course) => course.level.toLowerCase() == criteres.level.toLowerCase());
        }

        setCourses(result);
    }


    return (
        <div id="wrapper">

            <Header />

            <div className="page-content">

                <div className="container">

                    <div className="mt-lg-5" uk-grid="">

                        <CourseFilterSection handleFilter={handleFilter} courses={WebCourses} />

                        <div className="uk-width-expand@m">

                            <div className="section-header mb-lg-3">
                                <div className="section-header-left">
                                    <h4> Programmation Web </h4>
                                </div>
                                <div className="section-header-right">

                                    <div className="display-as">
                                        <a
                                            className={displayStyle == "card" ? "active" : ""}
                                            uk-tooltip="title: Course list; pos: top-right"
                                            onClick={() => { setDisplayStyle('card') }}
                                        >
                                            <i className="icon-feather-grid"></i>
                                        </a>
                                        <a
                                            className={displayStyle == "list" ? "active" : ""}
                                            uk-tooltip="title: Course Grid; pos: top-right"
                                            onClick={() => { setDisplayStyle('list') }}
                                        >
                                            <i className="icon-feather-list"></i>
                                        </a>
                                    </div>

                                    {/* <select className="selectpicker ml-3">
                                        <option value=""> Newest </option>
                                        <option value="1">Popular</option>
                                        <option value="2">Free</option>
                                        <option value="3">Premium</option>
                                    </select> */}


                                </div>
                            </div>

                            {displayStyle == "card" ? <CourseCardSection courses={courses} /> : <CourseListSection courses={courses} />}

                            <ul className="uk-pagination my-5 uk-flex-center" uk-margin="">
                                <li><a href="#"><span uk-pagination-previous=""></span></a></li>
                                <li className="uk-disabled"><span>...</span></li>
                                <li><a href="#">4</a></li>
                                <li className="uk-active"><span>7</span></li>
                                <li><a href="#">8</a></li>
                                <li><a href="#">10</a></li>
                                <li className="uk-disabled"><span>...</span></li>
                                <li><a href="#"><span uk-pagination-next=""></span></a></li>
                            </ul>

                        </div>

                    </div>

                </div>

            </div>

            <Footer />

        </div>

    )
}

export default CoursesScreen
